// src/main.jsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';
import axios from './axiosConfig';
import { ServiceAvailabilityProvider } from './contexts/ServiceAvailabilityContext';

// Set axios base URL from Vite environment variable
axios.defaults.baseURL = import.meta.env.VITE_API_URL;

const container = document.getElementById('root');
const root = createRoot(container);

// Note: StrictMode disabled due to react-leaflet incompatibility with React 19
// (Leaflet map container gets initialized twice in StrictMode)
root.render(<ServiceAvailabilityProvider><App /></ServiceAvailabilityProvider>);
